var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.08464 15.8327H6.66797C3.33464 15.8327 1.66797 14.9993 1.66797 10.8327V6.66602C1.66797 3.33268 3.33464 1.66602 6.66797 1.66602H13.3346C16.668 1.66602 18.3346 3.33268 18.3346 6.66602V10.8327C18.3346 14.166 16.668 15.8327 13.3346 15.8327H12.918C12.6596 15.8327 12.4096 15.9577 12.2513 16.166L11.0013 17.8327C10.4513 18.566 9.5513 18.566 9.0013 17.8327L7.7513 16.166C7.61797 15.9827 7.30964 15.8327 7.08464 15.8327Z",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83203 6.66602H14.1654",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83203 10.832H10.832",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageText);
export default __webpack_public_path__ + "static/media/message-text.67b2ace6.svg";
export { ForwardRef as ReactComponent };